import React, { useState } from "react";

import styles from "./KeyWord.module.css";

interface Props {
  keyword:string,
  updateKeyWord: (keyword: string) => void;
}

function KeyWord(props: Props) {
  const { updateKeyWord } = props;
  const [word, setWord] = useState("");
  return (
    <div className={styles.container}>
      <input 
        type="text" 
        className={styles.input} 
        value={word} 
        placeholder='搜索关键词：如“房产”' 
        onChange={(e)=>{
          const word = (e && e.target && e.target.value) || ""
          setWord(word)
        }}
        onKeyUp={(e)=>{
          if(e && e.keyCode==13){
            updateKeyWord(word)
          }
        }}
      />
      <div 
        className={styles.btn}
        onClick={()=>{
          updateKeyWord(word)
        }}
      ></div>
    </div>
  );
}

export default KeyWord;
